(function() {
  function replaceEmailInPolicy() {
    const body = document.querySelector('.shopify-policy__body');
    if (body) {
      const isOrderPolicy = window.location.pathname.includes('refund-policy') || window.location.pathname.includes('shipping-policy');
      const targetEmail = isOrderPolicy ? 'orders@teravie.in' : 'info@teravie.in';
      body.innerHTML = body.innerHTML.replace(/care@teravie\.in/g, targetEmail)
                                      .replace(/teraviebeauty@gmail\.com/g, targetEmail)
                                      .replace(/info@teravie\.in/g, targetEmail);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', replaceEmailInPolicy);
  } else {
    replaceEmailInPolicy();
  }
})();
